import React, { useState, useRef } from 'react';
import parse from 'html-react-parser';
import {
  Modal,
  Button,
  Row,
  Col,
  Form,
  ListGroup,
  ListGroupItem,
} from 'react-bootstrap';
import ApiUtils from '../../utils/api_utils';
import './style.scss';

export const DialogLayout = ({
  onHide,
  children,
  show,
  title,
  isStatic = true,
}) => {
  return (
    <Modal
      onHide={onHide}
      show={show}
      size="lg"
      backdrop={isStatic ? 'static' : 'false'}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {title && <Modal.Title>{title}</Modal.Title>}
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export const CustomDialog = (props) => {
  return (
    <DialogLayout onHide={props.onHide} show={props.show}>
      <div className="title-modal">
        <strong>{props.title}</strong>
      </div>
      {props.content}
      <Button className={`btn-modal`} onClick={props.onHide}>
        {props.buttonText}
      </Button>
    </DialogLayout>
  );
};

export const CustomDialogNew = (props) => {
  const {
    onHide,
    show,
    content,
    onConfirm,
    onCancel,
    cancelLabel = 'No',
    confirmLabel = 'Yes',
    isConfirm = false,
    variant = 'outline-warning',
  } = props;
  return (
    <DialogLayout onHide={onHide} show={show}>
      {content}
      {isConfirm ? (
        <Button variant={variant} onClick={onCancel} className="btn-confrim">
          {cancelLabel}
        </Button>
      ) : (
        ''
      )}
      <Button variant={variant} onClick={onConfirm} className="btn-confrim">
        {confirmLabel}
      </Button>
    </DialogLayout>
  );
};

export const InformationDialog = ({
  title = 'Information',
  message,
  icon,
  onHide,
  closeLabel = 'Back',
  show = false,
  style = { width: 'auto' },
}) => {
  return (
    <DialogLayout onHide={onHide} show={show}>
      <div className="title-modal">{title}</div>
      {icon && (
        <div className="icon-modal">
          <img
            src={icon}
            className="icon-view"
            width="50px"
            height="50px"
            alt=""
          />
        </div>
      )}
      <div style={style} className="message-modal">
        {parse(message)}
      </div>
      <Button className="btn-modal border-0" onClick={onHide}>
        {closeLabel}
      </Button>
    </DialogLayout>
  );
};

const RenderDefaultBtnConfirmationDialog = ({
  onConfrim,
  confirmLabel,
  onCancel,
  cancelLabel,
}) => {
  return (
    <div>
      <Button onClick={onCancel} className="btn-confrim">
        {cancelLabel}
      </Button>
      <Button onClick={onConfrim} className="btn-confrim">
        {confirmLabel}
      </Button>
    </div>
  );
};

const RenderCustomBtnConfirmationDialog = ({
  onConfrim,
  confirmLabel,
  onCancel,
  cancelLabel,
}) => {
  return (
    <div>
      <Button onClick={onConfrim} className="btn-danger">
        {confirmLabel}
      </Button>
      <Button onClick={onCancel} className="btn-confrim btn-outline-danger">
        {cancelLabel}
      </Button>
    </div>
  );
};

export const ConfirmationDialog = ({
  title = '',
  message,
  onConfrim,
  onCancel,
  cancelLabel = 'No',
  confirmLabel = 'Yes',
  show = false,
  isCustomBtn = false,
  style = { width: 'auto' },
}) => {
  return (
    <DialogLayout
      onHide={onCancel}
      show={show}
      isStatic={isCustomBtn ? false : true}
    >
      <div className="title-modal">{title}</div>
      <div style={style} className="message-modal">
        {message}
      </div>
      {isCustomBtn ? (
        <RenderCustomBtnConfirmationDialog
          onConfrim={onConfrim}
          confirmLabel={confirmLabel}
          onCancel={() => onCancel(true)}
          cancelLabel={cancelLabel}
        />
      ) : (
        <RenderDefaultBtnConfirmationDialog
          onConfrim={onConfrim}
          confirmLabel={confirmLabel}
          onCancel={onCancel}
          cancelLabel={cancelLabel}
        />
      )}
    </DialogLayout>
  );
};

const RenderCustomBtnConfirmationDialogMulti = ({
  onConfrim1,
  confirmLabel1,
  onConfrim2,
  confirmLabel2,
  onCancel,
  cancelLabel,
}) => {
  return (
    <div>
      <button onClick={onConfrim1} className="btn-no-border btn">
        {confirmLabel1}
      </button>
      <button onClick={onConfrim2} className="btn-no-border btn">
        {confirmLabel2}
      </button>
      <Button onClick={onCancel} className="btn-confrim btn-outline-danger">
        {cancelLabel}
      </Button>
    </div>
  );
};

export const ConfirmationDialogMulti = ({
  title = '',
  message,
  onConfrim1,
  onConfrim2,
  onCancel,
  cancelLabel = 'No',
  confirmLabel1 = 'Yes',
  confirmLabel2 = 'Yes',
  show = false,
  isCustomBtn = false,
  style = { width: 'auto' },
}) => {
  return (
    <DialogLayout
      onHide={onCancel}
      show={show}
      isStatic={isCustomBtn ? false : true}
    >
      {isCustomBtn ? (
        <RenderCustomBtnConfirmationDialogMulti
          onConfrim1={onConfrim1}
          confirmLabel1={confirmLabel1}
          onConfrim2={onConfrim2}
          confirmLabel2={confirmLabel2}
          onCancel={() => onCancel(true)}
          cancelLabel={cancelLabel}
        />
      ) : (
        <RenderCustomBtnConfirmationDialogMulti
          onConfrim1={onConfrim1}
          confirmLabel1={confirmLabel1}
          onConfrim2={onConfrim2}
          confirmLabel2={confirmLabel2}
          onCancel={onCancel}
          cancelLabel={cancelLabel}
        />
      )}
    </DialogLayout>
  );
};

export const RedeemDialog = ({
  title = 'Successful',
  message,
  iconRedeem,
  voucherRedeemName,
  voucherRedeemDescription,
  onHide,
  redeemptionType,
  closeLabel = 'OK',
  showDescription,
  show = false,
}) => {
  let dataMessage = '';

  if (title === 'Unsuccessful' && redeemptionType === 'electricity_topup') {
    dataMessage = 'Invalid PLN number, must be digits';
  } else if (
    title === 'Unsuccessful' &&
    (redeemptionType === 'mobile_topup' ||
      redeemptionType === 'gopay' ||
      redeemptionType === 'balance_topup')
  ) {
    dataMessage = 'Missing or invalid mobile number, must be at least 9 digits';
  } else {
    dataMessage = message;
  }

  return (
    <DialogLayout onHide={onHide} show={show}>
      <div className="title-modal">{title}</div>
      {iconRedeem && (
        <Row className="icon-modal">
          <Col xs={4} sm={4} md={4}>
            <img
              src={ApiUtils.validateImgUrl({ url: iconRedeem })}
              className="img-modal"
            />
          </Col>
          <Col className="voucher-info">
            <Row>
              <Col className="voucher-name">{voucherRedeemName}</Col>
            </Row>
            {showDescription && (
              <Row>
                <Col className="voucher-description">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: voucherRedeemDescription,
                    }}
                  />
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      )}
      <div className="message-modal">
        <div dangerouslySetInnerHTML={{ __html: dataMessage }} />
      </div>
      <Button
        variant="outline-danger"
        className="btn-ok-redeem-dialog"
        onClick={onHide}
      >
        {closeLabel}
      </Button>
    </DialogLayout>
  );
};

export const SelectAddressDialog = ({
  title,
  listAddress = [],
  onHide,
  show = false,
  indexAddress,
  setIndexAddress,
}) => {
  const [selectedAddress, setSelectedAddress] = useState(indexAddress);

  return (
    <DialogLayout onHide={onHide} show={show}>
      <div className="title-modal">{title}</div>
      <div className="address-list">
        {listAddress &&
          listAddress.map((item, index) => (
            <Form.Check
              label={item.address}
              name="address"
              type="radio"
              key={index}
              onChange={() => {
                setSelectedAddress(index);
              }}
              value={selectedAddress}
              checked={selectedAddress === index ? true : false}
            />
          ))}
      </div>
      <Button
        variant="danger"
        className="btn-ok-address-dialog"
        onClick={() => {
          setIndexAddress(selectedAddress);
        }}
      >
        Select
      </Button>
    </DialogLayout>
  );
};

export const AttachmentDialog = ({
  onClose,
  show,
  attachmentType,
  setAttachmentType,
  showAttachmentCamera,
  payload,
  setPayload,
}) => {
  const fileInputRef = useRef(null);
  const fileType =
    attachmentType == 'photo' || attachmentType == 'docphoto'
      ? ['.jpg', '.jpeg', '.png', '.gif']
      : ['.mp4', '.avi', '.mov', '.mkv'];

  const onHandleAttachmentCamera = () => {
    onClose();
    showAttachmentCamera();
  };

  const onHandleGalleryClick = () => {
    fileInputRef.current.click();
  };

  const closeAttachmentDialog = () => {
    onClose();
    switch (attachmentType) {
      case 'photo':
        if (payload.img == '') {
          setAttachmentType('');
        }
        break;
      case 'video':
        if (!payload.video) {
          setAttachmentType('');
        }
        break;
      default:
        break;
    }
  };

  const handleFileSelected = (event) => {
    onClose();
    const file = event.target.files[0];
    if (attachmentType == 'photo' || attachmentType == 'docphoto') {
      if (!payload.img) {
        setPayload({ ...payload, img: file });
      } else {
        if (!payload.img2) {
          setPayload({ ...payload, img2: file });
        } else {
          setPayload({ ...payload, img3: file });
        }
      }
    } else {
      setPayload({ ...payload, video: file });
    }
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      backdrop="static"
      keyboard={false}
      className="modal-select-attachment"
    >
      <Modal.Header>
        <Modal.Title>Please select</Modal.Title>
        <div className="select-attachment-header-detail">
          How you would like take from?
        </div>
        <div className="fs-12">(maximum upload 2 images)</div>
      </Modal.Header>
      <Modal.Body>
        <ListGroup className="list-group-select-attachment">
          <ListGroupItem
            className="list-item-select-attachment"
            onClick={onHandleAttachmentCamera}
          >
            Camera
          </ListGroupItem>
          <ListGroupItem
            className="list-item-select-attachment"
            onClick={onHandleGalleryClick}
          >
            Gallery
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              accept={fileType}
              onChange={handleFileSelected}
            />
          </ListGroupItem>
          <ListGroupItem
            className="list-item-select-attachment"
            onClick={closeAttachmentDialog}
          >
            Cancel
          </ListGroupItem>
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
};

export const ReceiptAttachmentDialog = ({
  onClose,
  show,
  attachmentType,
  setAttachmentType,
  showAttachmentCamera,
  payload,
  setPayload,
  typeAction,
}) => {
  const fileInputRef = useRef(null);
  const fileType = ['.jpg', '.jpeg', '.png', '.gif'];

  const onHandleAttachmentCamera = () => {
    onClose();
    showAttachmentCamera();
  };

  const onHandleGalleryClick = () => {
    fileInputRef.current.click();
  };

  const closeAttachmentDialog = () => {
    onClose();
    switch (attachmentType) {
      case 'photo':
        if (payload.img == '') {
          setAttachmentType('');
        }
        break;
      case 'video':
        if (!payload.video) {
          setAttachmentType('');
        }
        break;
      default:
        break;
    }
  };

  const handleFileSelected = (event) => {
    onClose();
    const file = event.target.files[0];
    if (attachmentType == 'photo' || attachmentType == 'docphoto') {
      if (typeAction === 'retry') {
        if (payload.img) {
          setPayload({ ...payload, img: file });
        }
        if (payload.img2) {
          setPayload({ ...payload, img2: file });
        }
      } else {
        if (!payload.img) {
          setPayload({ ...payload, img: file });
        } else if (!payload.img2) {
          setPayload({ ...payload, img2: file });
        }
      }
    } else {
      setPayload({ ...payload, video: file });
    }
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      backdrop="static"
      keyboard={false}
      className="modal-select-attachment"
    >
      <Modal.Header>
        <Modal.Title>Please select</Modal.Title>
        <div className="select-attachment-header-detail">
          How you would like take from?
        </div>
        <div className="fs-12">(maximum upload 2 images)</div>
      </Modal.Header>
      <Modal.Body>
        <ListGroup className="list-group-select-attachment">
          <ListGroupItem
            className="list-item-select-attachment"
            onClick={onHandleAttachmentCamera}
          >
            Camera
          </ListGroupItem>
          <ListGroupItem
            className="list-item-select-attachment"
            onClick={onHandleGalleryClick}
          >
            Gallery
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              accept={fileType}
              onChange={handleFileSelected}
            />
          </ListGroupItem>
          <ListGroupItem
            className="list-item-select-attachment"
            onClick={closeAttachmentDialog}
          >
            Cancel
          </ListGroupItem>
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
};

export const SubmitCreateReportDialogSuccess = ({ onClose, show }) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      backdrop="static"
      keyboard={false}
      className="modal-submit-success"
    >
      <Modal.Header>
        <Modal.Title>Report Sent</Modal.Title>
        <div className="modal-submit-success-header-detail">
          Thank you. Admin will review your report shortly.
        </div>
      </Modal.Header>
      <Modal.Body>
        <ListGroup className="list-group-submit-success">
          <ListGroupItem className="list-item-submit-success" onClick={onClose}>
            Done
          </ListGroupItem>
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
};

export const SubmitCreatePostDialogSuccess = ({ onClose, show }) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      backdrop="static"
      keyboard={false}
      className="modal-submit-success"
    >
      <Modal.Header>
        <Modal.Title>Post Submitted</Modal.Title>
        <div className="modal-submit-success-header-detail">
          Thank you. Your article has been submitted for review.
        </div>
      </Modal.Header>
      <Modal.Body>
        <ListGroup className="list-group-submit-success">
          <ListGroupItem className="list-item-submit-success" onClick={onClose}>
            Done
          </ListGroupItem>
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
};

export const SubmitCreatePostDialogValidation = ({
  onClose,
  show,
  messageValidation,
}) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      backdrop="static"
      keyboard={false}
      className="modal-submit-validation"
    >
      <Modal.Header>
        <Modal.Title>Submit Post Error</Modal.Title>
        <div className="modal-submit-validation-header-detail">
          {messageValidation}
        </div>
      </Modal.Header>
      <Modal.Body>
        <ListGroup className="list-group-submit-validation">
          <ListGroupItem
            className="list-item-submit-validation"
            onClick={onClose}
          >
            Close
          </ListGroupItem>
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
};
export const SubmitCreateReportDialogValidation = ({
  onClose,
  show,
  messageValidation,
}) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      backdrop="static"
      keyboard={false}
      className="modal-submit-validation"
    >
      <Modal.Header>
        <Modal.Title>Submit Report Error</Modal.Title>
        <div className="modal-submit-validation-header-detail">
          {messageValidation}
        </div>
      </Modal.Header>
      <Modal.Body>
        <ListGroup className="list-group-submit-validation">
          <ListGroupItem
            className="list-item-submit-validation"
            onClick={onClose}
          >
            Close
          </ListGroupItem>
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
};
